import load from './load';
import { AutocompleteDataResult, LoadAutocompleteData } from './types';
import withDefault from './withDefault';

const getData = (inputData: LoadAutocompleteData): AutocompleteDataResult => {
  const input = withDefault(inputData);
  const { accountId, backing } = input;

  if (!backing.hasItem(accountId)) {
    return {
      data: backing.defaultValue,
      promise: load(input).then((result) => ({
        result,
        isNewData: true,
      })),
    };
  }

  const data = backing.getItem(accountId);
  return {
    data,
    promise: Promise.resolve({ result: data, isNewData: false }),
  };
};

export default getData;
